<template>
  <div>
    <Logo></Logo>
    <Gallery></Gallery>
    <TripMap :trip="trip" :loading="loading"></TripMap>
    <RightPanel :trip="trip"></RightPanel>
    <submit></submit>
    <contact></contact>
    <isuFooter></isuFooter>
  </div>
</template>

<script>
import Logo from '@/components/Logo'
import TripMap from '@/components/TripMap'
import RightPanel from '@/components/RightPanel'
import algoliasearch from 'algoliasearch'
import { mapActions } from 'vuex'
import Gallery from '@/components/Gallery'
import isuFooter from '@/components/Footer'
import router from '@/router'
import submit from '@/components/Submit'
import contact from '@/components/Contact'

export default {
  name: 'trip',
  mounted () {
    this.getTrip()
  },
  components: {
    Logo: Logo,
    TripMap: TripMap,
    RightPanel: RightPanel,
    isuFooter: isuFooter,
    Gallery: Gallery,
    submit: submit,
    contact: contact
  },
  data () {
    return {
      trip: {},
      loading: true
    }
  },
  methods: {
    ...mapActions([
      'setCurrentDest'
    ]),
    getTrip () {
      // Algolia
      var client = algoliasearch('K2PX6XUYZD', 'ab6ff564e0cedf34e0716ad88fa36701')
      var index = client.initIndex('isustudyabroad')
      // console.log(this.$route)
      var reg = new RegExp('^\\d+$')
      var id = this.$route.params.id

      index.search(id, (err, content) => {
        if (err) {
          console.log(err)
        } else {
          console.log(content)
          if (content.hits.length === 0) {
            router.push({ name: 'Home' })
          } else {
            this.trip = content.hits[0]
            this.setCurrentDest(this.trip.acf.destinations[0])
          }
        }
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Trip.vue?6d995219